<template>
  <b-button
    class="custom-button"
    :class="customClass"
    :type="type"
    :disabled="loading || disabled"
  >
    <div class="d-flex align-items-center">
      <span v-if="!loading && iconLeft" :class="iconClass">
        <feather-icon
          :icon="iconLeft"
          class="ml-1 mr-1"
          :class="textClass"
          size="1x"
        />
      </span>
      <span :class="textClass">{{ btnLabel }}</span>
      <span v-if="!loading && iconRight" :class="iconClass">
        <feather-icon
          :icon="iconRight"
          class="ml-1 mr-1"
          :class="textClass"
          size="1x"
        />
      </span>
      <b-spinner v-if="loading" small class="ml-1" :class="loadingClass" />
    </div>
  </b-button>
</template>

<script>
import { BButton, BSpinner } from "bootstrap-vue";

export default {
  components: {
    BButton,
    BSpinner,
  },
  props: {
    btnLabel: { type: String, default: "Confirm" },
    type: { type: String, default: "button" },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    textClass: { type: String, default: "" },
    customClass: { type: String, default: "" },
    loadingClass: { type: String, default: "" },
    iconLeft: { type: String, default: "" },
    iconRight: { type: String, default: "" },
    iconClass: { type: String, default: "" },
  },
};
</script>

<style scoped>
.custom-button {
  padding: 15px 24px;
}
</style>
